const Alarm = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='16'
    height='16'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.41625 5.74622H8.16625V10.7462L12.1246 13.1212L12.7496 12.0962L9.41625 10.1212V5.74622ZM13.4471 0.587891L17.2862 3.79206L16.2196 5.07122L12.3779 1.86872L13.4471 0.587891ZM4.55208 0.587891L5.62041 1.86789L1.78041 5.07122L0.713745 3.79122L4.55208 0.587891ZM8.99958 2.41289C4.85791 2.41289 1.49958 5.77122 1.49958 9.91289C1.49958 14.0546 4.85791 17.4129 8.99958 17.4129C13.1412 17.4129 16.4996 14.0546 16.4996 9.91289C16.4996 5.77122 13.1412 2.41289 8.99958 2.41289ZM8.99958 15.7462C5.78291 15.7462 3.16625 13.1296 3.16625 9.91289C3.16625 6.69622 5.78291 4.07956 8.99958 4.07956C12.2162 4.07956 14.8329 6.69622 14.8329 9.91289C14.8329 13.1296 12.2162 15.7462 8.99958 15.7462Z'
      fill='currentColor'
    />
  </svg>
);

export default Alarm;
